// extracted by mini-css-extract-plugin
export var whatWeDoCoverSection = "whatWeDoCover-module--whatWeDoCoverSection--+Uezv";
export var whatWeDocontent = "whatWeDoCover-module--whatWeDocontent--RdbgZ";
export var svgWrapper = "whatWeDoCover-module--svgWrapper--ZUYLH";
export var dark_section = "whatWeDoCover-module--dark_section--RYDwF";